import { sizes } from '@lmc/common/constants'
import { EmptyState, NoDataIcon, RangePicker } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import Actions from '../../../actions'
import { Spinner } from '../../../components/generic'
import Operations from '../../../operations'
import Selectors from '../../../selectors'
import HandoversHistory from '../components/handovers/HandoversHistory'
import { HandoversPaywall } from '../components/handovers/HandoversPaywall'

export class HandoversHistoryScreen extends Component {
  componentDidMount() {
    const { fetchHandoverHistory, handoverHistory } = this.props
    if (!handoverHistory) fetchHandoverHistory()
  }

  setDateRange = (datesRange) => {
    // eslint-disable-next-line react/prop-types
    const { fetchHandoverHistory, setDateRange } = this.props

    const startDate = datesRange?.[0]
    const endDate = datesRange?.[1]

    const newStartDate = dayjs(startDate).startOf('day')
    const newEndDate = dayjs(endDate).endOf('day')

    const maxEndDate = newStartDate.add(14, 'day')

    if (maxEndDate < newEndDate) {
      setDateRange({
        startDate: newStartDate || null,
        endDate: maxEndDate
      })
    } else {
      setDateRange({
        startDate: newStartDate || null,
        endDate: newEndDate || null
      })
    }
    // setDateRange({
    //   startDate: newStartDate || null,
    //   endDate: newEndDate || null,
    // })
    fetchHandoverHistory()
  }

  renderHandoverHistory = () => {
    const { fetchHandoverData, handoverHistory } = this.props
    if (!handoverHistory) return <Spinner />
    if (!Object.keys(handoverHistory).length) {
      return (
        <EmptyState
          icon={<NoDataIcon />}
          title="Shoot... no handover information to show you"
        />
      )
    }
    return (
      <HandoversHistory
        handovers={handoverHistory}
        onHandoverOpen={fetchHandoverData}
      />
    )
  }

  renderContent = () => {
    const {
      home,
      isLoading,
      // isEmpty,
      dateRange: { startDate, endDate }
    } = this.props

    if (!isLoading && !home?.features?.handovers?.enabled) {
      return <HandoversPaywall />
    }

    const isFutureDate = (currentDate) => currentDate > dayjs()

    return (
      <div>
        <div style={styles.dateRangePicker}>
          <RangePicker
            disabledDate={isFutureDate}
            onChange={this.setDateRange}
            value={[startDate, endDate]}
          />
        </div>
        {this.renderHandoverHistory()}
      </div>
    )
  }

  render() {
    const { home } = this.props
    const container = home?.features?.handovers?.enabled
      ? { ...styles.mainContainer, ...styles.handoversContainer }
      : styles.mainContainer
    return <div style={container}>{this.renderContent()}</div>
  }
}

const styles = {
  mainContainer: {
    width: '100%',
    margin: '0 auto',
    height: '85vh'
  },
  handoversContainer: {
    padding: '24px 24px',
    maxWidth: sizes.childScreen
  },
  dateRangePicker: { marginBottom: 22 },
  supportLink: {
    display: 'inline-block',
    marginTop: 12
  }
}

HandoversHistoryScreen.propTypes = {
  dateRange: PropTypes.object,
  isLoading: PropTypes.bool,
  isEmpty: PropTypes.bool,
  fetchHandoverData: PropTypes.func.isRequired,
  fetchHandoverHistory: PropTypes.func.isRequired,
  handoverHistory: PropTypes.object,
  home: PropTypes.object
}

const mapStateToProps = (state) => ({
  isLoading: !state.handovers || !state.handovers.history,
  isEmpty: state.handovers && state.handovers.history?.length === 0,
  dateRange: state.handovers.historyDateRange,
  handoverHistory: Selectors.formatHandoverHistory(state),
  home: state.global.home
})

const mapDispatchToProps = (dispatch) => ({
  fetchHandoverData: (id) => dispatch(Operations.fetchHandoverHistoryItem(id)),
  fetchHandoverHistory: () => {
    dispatch(Operations.fetchHandoverHistory())
  },
  setDateRange: (range) => dispatch(Actions.setHistoryDateRange(range))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HandoversHistoryScreen)
